import { useContext } from "react";

import { PresenceContext } from "./presence.context.js";

/**
 * We have two hooks to access User Presence. This one is dedicated to getting the presence of the current user.
 * The other one - useUserPresence - is for getting the presence of a specific user.
 */
export const useMyPresence = () => {
  const context = useContext(PresenceContext);

  if (!(context && context.__ctx_init === true)) {
    throw new Error(
      "useMyPresence hook must be used within a PresenceProvider"
    );
  }

  const { presence, updateAvailability, updateStatusMessage } = context;

  let statusMessage = presence?.statusMessage ?? null;
  if (presence?.outOfOffice?.isOutOfOffice) {
    statusMessage = presence?.outOfOffice?.message || "Out of office";
  }

  return {
    availability: context.availability,
    isOutOfOffice: presence?.outOfOffice?.isOutOfOffice ?? false,
    presenceError: context.presenceError,
    presenceStatus: context.presenceStatus,
    statusMessage,
    updateAvailability,
    updateStatusMessage,
  };
};
